var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopedCssBaseline = void 0;
var ScopedCssBaseline_1 = __importDefault(require("@material-ui/core/ScopedCssBaseline"));
exports.ScopedCssBaseline = ScopedCssBaseline_1.default;
exports.default = exports.ScopedCssBaseline;
//# sourceMappingURL=ScopedCssBaseline.js.map